var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"endorsement-title"},[_vm._v(_vm._s(_vm.$t("Fire Oranı")))]),_c('apexchart',{attrs:{"type":"pie","height":"400","options":_vm.chartOptions,"series":_vm.pieChartSeries}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }